import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useWhatsAppStore } from '../lib/whatsappStore';

interface WhatsAppContextType {
  selectedInstanceId: string | null;
  setSelectedInstanceId: (id: string | null) => void;
  selectedInstance: any | null;
}

const WhatsAppContext = createContext<WhatsAppContextType | undefined>(undefined);

export function WhatsAppProvider({ children }: { children: ReactNode }) {
  const [selectedInstanceId, setSelectedInstanceId] = useState<string | null>(() => {
    // Tenta recuperar a instância selecionada do localStorage
    const saved = localStorage.getItem('selectedWhatsAppInstance');
    return saved ? saved : null;
  });
  const { instances } = useWhatsAppStore();
    
  const selectedInstance = instances.find(instance => instance.id === selectedInstanceId);

  // Salva a seleção no localStorage sempre que mudar
  useEffect(() => {
    if (selectedInstanceId) {
      localStorage.setItem('selectedWhatsAppInstance', selectedInstanceId);
    } else {
      localStorage.removeItem('selectedWhatsAppInstance');
    }
  }, [selectedInstanceId]);

  const value = {
    selectedInstanceId,
    setSelectedInstanceId,
    selectedInstance
  };

  return (
    <WhatsAppContext.Provider value={value}>
      {children}
    </WhatsAppContext.Provider>
  );
}

export function useWhatsApp() {
  const context = useContext(WhatsAppContext);
  if (context === undefined) {
    throw new Error('useWhatsApp must be used within a WhatsAppProvider');
  }
  return context;
}
